import { Injectable, signal } from '@angular/core';

export type AppTheme = 'theme-vinho' | 'theme-salvia' | 'theme-azul';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // Tema padrão para o usuário: Vinho (Luxo/Premium)
  private currentThemeSignal = signal<AppTheme>('theme-vinho');
  
  constructor() {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('app-user-theme') as AppTheme;
      if (savedTheme && (savedTheme === 'theme-vinho' || savedTheme === 'theme-salvia' || savedTheme === 'theme-azul')) {
        this.setTheme(savedTheme);
      } else {
        this.setTheme('theme-vinho');
      }
    }
  }

  getThemeSignal() {
    return this.currentThemeSignal;
  }

  setTheme(theme: AppTheme) {
    this.currentThemeSignal.set(theme);
    if (typeof window !== 'undefined') {
      localStorage.setItem('app-user-theme', theme);
      this.applyTheme(theme);
    }
  }

  private applyTheme(theme: AppTheme) {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('theme-vinho', 'theme-salvia', 'theme-azul');
      document.body.classList.add(theme);
    }
  }
}
